import { useEffect } from "react";
import { useClerk } from "@clerk/clerk-react";
import { registerClerkLogout } from "../../clients/clerkBridge";

// Registers the Clerk SDK signOut function with the imperative clerkBridge so
// class-based / non-hook code (App.js logout + session expiry) can clear the
// Clerk session. Renders nothing. Only mounted when clerkEnabled is true.
//
// Note: clerk-react v4's signOut takes a callback, not a `{ redirectUrl }`
// option (that arrived in v5). We're pinned to v4 because spec-admin is on
// React 17 and v5 requires React >= 18.
const ClerkLogoutBridge = () => {
  const { signOut } = useClerk();

  useEffect(() => {
    registerClerkLogout(() =>
      signOut(() => {
        window.location.href = window.location.origin + "/login";
      })
    );
  }, [signOut]);

  return null;
};

export default ClerkLogoutBridge;
